import React from "react"
import { Navbar, Nav, Container } from "react-bootstrap"
import { NavLink } from "react-router-dom"
import { logoIcon } from "../constants/icons"
import UserDropdown from "./dropdown/UserDropdown"
import UserImage from "../assets/images/bickey.jpg"
import logo from "../assets/logo/logo.png"

function MainNavbar({ loggedIn, handleLogout }) {
  const storedUserName = localStorage.getItem("userName")
  const userName = storedUserName || "Guest"

  const user = loggedIn ? { avatar: UserImage, name: userName } : null

  return (
    <>
      <Navbar expand='lg' className='main-navigation sticky-top'>
        <Container>
          <Navbar.Brand href='/'>
            <img src={logo} alt='Logo' height={60} />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='nav-menu'>
              {/* <NavLink
                to='/'
                exact
                className='nav-link'
                activeClassName='active'
              >
                Home
              </NavLink>
              <NavLink
                to='/tutorial'
                className='nav-link'
                activeClassName='active'
              >
                Tutorial
              </NavLink> */}
              <NavLink
                to='/exam-papers'
                className='nav-link'
                activeClassName='active'
              >
                Exam papers
              </NavLink>
              <NavLink
                to='/practice-generator'
                className='nav-link'
                activeClassName='active'
              >
                Practice Generator
              </NavLink>
              {/* <NavLink
                to='/contact-us'
                className='nav-link'
                activeClassName='active'
              >
                Contact us
              </NavLink>
              <NavLink to='/help' className='nav-link' activeClassName='active'>
                Help
              </NavLink> */}
            </Nav>

            <div className='user-dropdown-wrapper'>
              {loggedIn ? (
                <UserDropdown user={user} handleLogout={handleLogout} />
              ) : (
                <></>
                // <Nav className='nav-button'>
                //   <NavLink to='/login' className='nav-link'>
                //     Login
                //   </NavLink>
                //   <NavLink to='/signup' className='nav-link btn-primary'>
                //     Sign up
                //   </NavLink>
                // </Nav>
              )}
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  )
}

export default MainNavbar
